<template>
  <div class="picker" :class="{'is-nested-color-options': shouldShowNestedPlanColors}" @click="(e) => e.stopPropagation()">
    <div
      :class="`picker__trigger ${colorOptions[selectedColorIndex]}`"
      :style="`background-color: ${selectedColor}; opacity: ${colorOptionOpacity(selectedColor)};`"
      @click="handleTriggerClick()"
    ></div>
    <div class="picker__popup" v-show="isOpen">
      <div
        v-for="(color, ind) in colorOptions"
        :class="`color-option ${ind === selectedColorIndex && 'isSelected'}`"
        :key="ind"
        :style="`background-color: ${color}; opacity: ${colorOptionOpacity(color)};`"
        @click="(e) => handleColorClick(color, e)"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'ColorPicker',
  props: {
    selectedColor: {
      type: String,
    },
    isLeadPlan: {
      type: Boolean,
    },
    forcePickerClosed: {
      type: Boolean,
      default: false
    },
    shouldShowNestedPlanColors: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isOpenLocal: false,
    }
  },
  computed: {
    colorOptions(): string[] {
      if(this.shouldShowNestedPlanColors){
        // Nested Plan color picker in Account Settings
        return [
          // Top Row
          this.$store.getters.initiativesPlanColor, // Initiatives
          '#FFD967', // Signage
          '#FF9767', // Paid Media & Advertising Assets
          '#F3739F', // Website
          '#DD79EB', // Email
          '#BE779C', // Custom
          '#C38D6D', // Custom

          // Bottom Row
          this.$store.getters.initiativesPlanColorLight, // Initiatives Light
          '#E3ED79', // Custom
          '#91D395', // PR
          '#7CE4DA', // Direct Mail
          '#67CDFF', // Collateral
          '#8D97D9', // Social Media
          '#A77AE1', // Custom
        ]
      }

      // Default, generally in channels
      return [
        // Top Row
        '#FFD967', // Signage
        '#FF9767', // Paid Media & Advertising Assets
        '#F3739F', // Website
        '#DD79EB', // Email
        '#BE779C', // Custom
        '#C38D6D', // Custom

        // Bottom Row
        '#E3ED79', // Custom
        '#91D395', // PR
        '#7CE4DA', // Direct Mail
        '#67CDFF', // Collateral
        '#8D97D9', // Social Media
        '#A77AE1', // Custom
      ]
    },
    selectedColorIndex(): number {
      return this.colorOptions.indexOf(this.selectedColor)
    },
    isOpen: {
      get(): boolean {
        if(this.forcePickerClosed){
          return false
        }
        return this.isOpenLocal
      },
      set(value: boolean) {
        this.isOpenLocal = value
      }
    }
  },
  watch: {
    forcePickerClosed(newVal: boolean) {
      if (newVal) {
        this.isOpenLocal = false
      }
    },
  },
  methods: {
    colorOptionOpacity(color: string): number {
      if (this.shouldShowNestedPlanColors) {
        return color === this.$store.getters.initiativesPlanColor || color === this.$store.getters.initiativesPlanColorLight ? 1 : 0.6
      }
      if (this.isLeadPlan || this.$store.getters.currentPlan.isLead) {
        return 1
      }
      return 0.6
    },
    handleTriggerClick(){
      this.$emit('triggerClicked')
      this.isOpen = !this.isOpen
      if(this.isOpen){
        this.$emit('opened')
      }else{
        this.$emit('closed')
      }
    },
    handleColorClick(color, e) {
      this.isOpen = false
      this.$emit('colorSelected', color, e)
    },
  },
})
</script>

<style lang="scss" scoped>
.picker {
  position: relative;
  // padding-top: 5px;
  &__trigger {
    width: 20px;
    height: 20px;
    background-color: #e3ed79;
  }
  &__popup {
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 180px;
    gap: 5px;
    padding: 15px;
    background-color: white;
    border: solid 1px black;
    z-index: 5;

    .color-option {
      width: calc((100% / 6) - 5px);
      border-radius: 50%;
      background-color: #e3ed79;
      aspect-ratio: 1;
      cursor: pointer;
      position: relative;

      &.isSelected {
        &:after {
          content: '';
          position: absolute;
          width: 5px;
          height: 10px;
          border-right: solid 2px white;
          border-bottom: solid 2px white;
          top: 42%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
        }
      }
    }
  }

  &.is-nested-color-options {
    .picker__popup {
      width: 210px;
    }
    .color-option {
      width: calc((100% / 7) - 5px);
    }
  }
}
</style>
